export default "__VITE_ASSET__NvWo3AEr__"